import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { TextStepHelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextAreaStepItem({
  item,
  label,
  params,
  onChange
}) {
  var _item$tooltip, _item$placeholder;
  const value = params[item.name];
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: item.required,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(TextStepHelpContent, {
      description: item.description,
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsx(TextArea, {
      onChange: event => onChange(item.name, event.target.value),
      value: value,
      placeholder: (_item$placeholder = item.placeholder) !== null && _item$placeholder !== void 0 ? _item$placeholder : undefined,
      resize: "vertical",
      rows: 8,
      wrap: "off"
    })
  });
}